import apiActionCreator from '../../common/service/api/actionCreator';
import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchPartNoList = () => apiActionCreator({
  'endpoint': '/parts/special-parts/partno-list/',
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_PART_NO_LIST_REQUEST,
    ActionTypes.FETCH_PART_NO_LIST_SUCCESS,
    [
      ActionTypes.FETCH_PART_NO_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const fetchSpecialPartList = (urlParameters = {}) => apiActionCreator({
  'endpoint': `/parts/special-parts/${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_SPECIAL_PART_LIST_REQUEST,
    ActionTypes.FETCH_SPECIAL_PART_LIST_SUCCESS,
    [
      ActionTypes.FETCH_SPECIAL_PART_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearSpecialPartList = () => ({
  'type': ActionTypes.CLEAR_SPECIAL_PART_LIST,
});

export const deleteSpecialPartRecord = (partno) => apiActionCreator({
  'endpoint': `/parts/special-parts/${partno}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_SPECIAL_PART_REQUEST,
    [
      ActionTypes.DELETE_SPECIAL_PART_SUCCESS,
      MessageActions.addMessageBoxInfo('Repuesto eliminado satisfactoriamente'),
    ],
    [
      ActionTypes.DELETE_SPECIAL_PART_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
});

export const fetchSpecialPartByPartno = (partno) => apiActionCreator({
  'endpoint': `/parts/special-parts/${partno}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_SPECIAL_PART_BY_CODE_REQUEST,
    ActionTypes.FETCH_SPECIAL_PART_BY_CODE_SUCCES,
    [
      ActionTypes.FETCH_SPECIAL_PART_BY_CODE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const editSpecialPart = (code, data) => apiActionCreator({
  'endpoint': `/parts/special-parts/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.EDIT_SPECIAL_PART_REQUEST,
    [
      ActionTypes.EDIT_SPECIAL_PART_SUCCESS,
      MessageActions.addMessageBoxInfo('Registro actualizado satisfactoriamente'),
    ],
    [
      ActionTypes.EDIT_SPECIAL_PART_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});


export const saveSpecialParts = (tableValues) => apiActionCreator({
  'endpoint': '/parts/special-parts/',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_SPECIAL_PART_LIST_REQUEST,
    [
      {'type': ActionTypes.SAVE_SPECIAL_PART_LIST_SUCCESS},
      (response) => buildSuccessMessage(response, 'Información subida satisfactoriamente'),
    ],
    [
      ActionTypes.SAVE_SPECIAL_PART_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': tableValues,
});

export const changeSpecialPartInformationPage = (newPage) => ({
  'type': ActionTypes.CHANGE_SPECIAL_PART_INFORMATION_PAGE,
  'payload': newPage,
});

export const changeSpecialPartInformationPageSize = (pageSize) => ({
  'type': ActionTypes.CHANGE_SPECIAL_PART_INFORMATION_PAGE_SIZE,
  'payload': pageSize,
});
